import '../../styles/templates/product.call-for-quote.css';

window.handleCAllForQuoteButton = function () {
  const callForQuoteTriger = document.querySelector(".call-for-quote-trigger");
  const callForQuoteForm = document.querySelector(".call-for-quote-form");
  callForQuoteTriger.classList.add("hidden");
  callForQuoteForm.classList.remove("hidden");
}
